import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { GraphicsTrainingNotes } from './components/GraphicsTrainingNotes';

function GraphicsTraining() {
  return (
    <div className="App">
      <GraphicsTrainingNotes />
     </div>
  );
}

export default GraphicsTraining;